/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationAffiliationModel } from '../../models/organization-affiliation-model';

export interface AdminFhirIdAffiliationAffiliationFhirIdGet$Params {
  fhirId: string;
  affiliationFhirId: string;
}

export function adminFhirIdAffiliationAffiliationFhirIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdAffiliationAffiliationFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationAffiliationModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdAffiliationAffiliationFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('affiliationFhirId', params.affiliationFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationAffiliationModel>;
    })
  );
}

adminFhirIdAffiliationAffiliationFhirIdGet.PATH = '/Admin/{fhirId}/Affiliation/{affiliationFhirId}';
